import React, {useState, useEffect} from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import {ReactComponent as Chart} from './images/chart.svg';
import Button from "./button";

const CaseStudy = ({ caseStudy, index, active, isFeatured }) => {
    const [isEven, setIsEven] = useState(false);
    const [tabActive, setTabActive] = useState("1");
    
    useEffect(() => {
        const isEven = () => {
            if (index % 2 === 0) {
                setIsEven(true);
            }
        } 
        isEven();
    }, [index]);

    const changeTab = (id) => {
        setTabActive(id);
    }

    function handleMonth(stat, id) {
        let moIndex = stat.indexOf('/mo');
        let statWOut = stat.slice(0, moIndex);
        let month = '<span style="font-size: 14px;">/mo</span>';
        let statWith = statWOut + month;
        if (document.getElementById(id)) {
            document.getElementById(id).innerHTML = statWith;
        }
    }

    return (
        <div className={"w-full px-6 pt-12 pb-24 flex flex-col items-center justify-center lg:pt-28 caseStudy" + (active ? " active" : "") + (isFeatured ? "bg-transparent" : isEven ? " bg-primaryBrand text-white lg:sticky top-0 min-h-screen" : " bg-white10 bg-cover bg-fixed text-black lg:sticky top-0 min-h-screen")} style={{zIndex: index + 10}}>
            <ScrollAnimation animateIn="fadeInUp" animateOnce="true" className="w-full">
                <div className={"container mx-auto w-full flex flex-col items-center md:gap-28 md:justify-between" + (isFeatured ? " lg:flex-row-reverse md:flex-col" : isEven ? " md:flex-row" : " md:flex-row-reverse")}>
                    <div className="w-full flex justify-center items-center px-6 pb-12 lg:w-1/2">
                        {!!caseStudy.logoWhite && !!caseStudy.logoBlack && (
                        <img src={isEven ? caseStudy.logoWhite.url : caseStudy.logoBlack.url} alt={caseStudy.companyName} loading="lazy" decoding="async" />
                        )}
                    </div>
                    <div className={"w-full" + (isFeatured ? " lg:w-full" : " lg:w-1/2") + " text-left flex flex-col gap-6 font-bold"}>
                        {isFeatured && (
                            <p className="text-sm md:text-base pointer-events-none uppercase">Featured Case Study</p>
                        )}
                        <h2 className="lg:text-5xl text-3xl pointer-events-none">{caseStudy.companyName}</h2>
                        <div className="flex flex-row gap-4 flex-wrap">
                            <p className={"text-sm md:text-base cursor-pointer p-1 border-b-solid" + (tabActive === '1' ? " border-b" : "") + (isEven ? " border-b-white" : " border-b-black")} onClick={() => changeTab('1')}>Background</p>
                            <p className={"text-sm md:text-base cursor-pointer p-1 border-b-solid" + (tabActive === '2' ? " border-b" : "") + (isEven ? " border-b-white" : " border-b-black")} onClick={() => changeTab('2')}>Challenges</p>
                            <p className={"text-sm md:text-base cursor-pointer p-1 border-b-solid" + (tabActive === '3' ? " border-b" : "") + (isEven ? " border-b-white" : " border-b-black")} onClick={() => changeTab('3')}>Solution</p>
                            <p className={"text-sm md:text-base cursor-pointer p-1 border-b-solid" + (tabActive === '4' ? " border-b" : "") + (isEven ? " border-b-white" : " border-b-black")} onClick={() => changeTab('4')}>Results</p>
                            <p className={"text-sm md:text-base cursor-pointer p-1 border-b-solid" + (tabActive === '5' ? " border-b" : "") + (isEven ? " border-b-white" : " border-b-black")} onClick={() => changeTab('5')}>Conclusion</p>
                        </div>
                        <div className={"relative text-base leading-8" + (isFeatured ? " h-96 md:h-80 lg:h-72" : " h-96")}>
                            <p className={"pointer-events-none absolute top left transition-opacity duration-1000" + (tabActive === '1' ? " opacity-100" : " opacity-0")}>{caseStudy.backgroundCopy}</p>
                            <p className={"pointer-events-none absolute top left transition-opacity duration-1000" + (tabActive === '2' ? " opacity-100" : " opacity-0")}>{caseStudy.challengesCopy}</p>
                            <p className={"pointer-events-none absolute top left transition-opacity duration-1000" + (tabActive === '3' ? " opacity-100" : " opacity-0")}>{caseStudy.solutionCopy}</p>
                            <p className={"pointer-events-none absolute top left transition-opacity duration-1000" + (tabActive === '4' ? " opacity-100" : " opacity-0")}>{caseStudy.resultsCopy}</p>
                            <p className={"pointer-events-none absolute top left transition-opacity duration-1000" + (tabActive === '5' ? " opacity-100" : " opacity-0")}>{caseStudy.conclusionCopy}</p>
                        </div>
                        <div className={"flex flex-row gap-5 justify-between items-start text-center" + (isFeatured ? " md:w-full md:flex-row flex-col items-center justify-center" : " ")}>
                            <div className="w-1/3 gap-2 flex flex-column items-center justify-center">
                                <ScrollAnimation animateIn="fadeInUp" delay={500} animateOnce="true">
                                    <p className="text-3xl pointer-events-none" id={caseStudy.companyName + '-statisticNumber1'}>{
                                        !!(caseStudy.statisticNumber1) ? (
                                            caseStudy.statisticNumber1.includes('/mo') ?
                                            handleMonth(caseStudy.statisticNumber1, caseStudy.companyName + '-statisticNumber1')
                                            : caseStudy.statisticNumber1
                                        )
                                        :(
                                            !!(caseStudy.statisticText1) ? 
                                            <Chart />
                                            : null
                                        )
                                    }</p>
                                    {!!(caseStudy.statisticText1) ?
                                        <p className="text-sm font-normal pointer-events-none">{caseStudy.statisticText1}</p>
                                    : null }
                                </ScrollAnimation>
                            </div>
                            <div className="w-1/3 gap-2 flex flex-column items-center justify-center">
                                <ScrollAnimation animateIn="fadeInUp" delay={1000} animateOnce="true">
                                        <p className="text-3xl pointer-events-none" id={caseStudy.companyName + '-statisticNumber2'}>{
                                            !!(caseStudy.statisticNumber2) ? (
                                                caseStudy.statisticNumber2.includes('/mo') ?
                                                handleMonth(caseStudy.statisticNumber2, caseStudy.companyName + '-statisticNumber2')
                                                : caseStudy.statisticNumber2
                                            )
                                            : (
                                                !!(caseStudy.statisticText2) ? 
                                                <Chart />
                                                : null
                                            )
                                        }</p>
                                    {!!(caseStudy.statisticText2) ?
                                        <p className="text-sm font-normal pointer-events-none">{caseStudy.statisticText2}</p>
                                    : null }
                                </ScrollAnimation>
                            </div>
                            <div className="w-1/3 gap-2 flex flex-column items-center justify-center">
                                <ScrollAnimation animateIn="fadeInUp" delay={1500} animateOnce="true">
                                    <p className="text-3xl pointer-events-none" id={caseStudy.companyName + '-statisticNumber3'}>{
                                        !!(caseStudy.statisticNumber3) ? 
                                        (
                                            caseStudy.statisticNumber3.includes('/mo') ? 
                                            handleMonth(caseStudy.statisticNumber3, caseStudy.companyName + '-statisticNumber3')
                                            : caseStudy.statisticNumber3
                                        )
                                        : (
                                            !!(caseStudy.statisticText3) ? 
                                            <Chart />
                                            : null
                                        )
                                    }</p>
                                    {!!(caseStudy.statisticText3) ?
                                    <p className="text-sm font-normal pointer-events-none">{caseStudy.statisticText3}</p>
                                    : null }
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollAnimation>
            {isFeatured && (
                <div className="w-full flex justify-center items-center mt-16">
                    <Button to="/portfolio" label="All Case Studies" variant="light-secondary" isHashLink={false} />
                </div>
            )}
        </div>
    )
}

export default CaseStudy;